// NHMSubsidy.js
import React from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import FooterwithoutLogin from "../../Pages Without Login/controllEnvironmentPolyhouse/footerwithoutLogin";
import { FaAngleRight } from "react-icons/fa";
import { enquiryInfo } from "../../SchemaInfo/enquiryInfo";
import { enquirySchema } from "../../Schemas/Enquiry/enquiry_schema";
import { Formik, Form } from "formik";
import CustomInput from "../../CustomComponent/custom_input";
import FormSubmitButton from "../../Components/layouts/formSubmitButton";
import { useState } from "react";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import LoadingPage from "../../Components/layouts/loading";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { BsBoxArrowInRight } from "react-icons/bs";
import { useEffect } from "react";

const NHMSubsidy = () => {
  const { state, city } = useParams();
  const [loading, setLoading] = useState(false);
  const [district, setDistrict] = useState([]);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/subsidy/get-district/?state=${state}`)
      .then((res) => {
        if (res.status === 201) {
          const first15Districts = res.data
            .slice(0, 15)
            .map((d) => d.toLowerCase());

            console.log('data is',first15Districts);

          setDistrict(first15Districts);
        } else {
          Toast("error", "Error while getting application!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [state]);

  const handelSubmit = (values, actions) => {
    values = { ...values, origin: "NHM-Alpha" };

    // const formData = new FormData();

    // for (let key in values) {
    //   if (values[key] instanceof File || values[key] instanceof Blob) {
    //     formData.append(key, values[key]);
    //   } else if (typeof values[key] === "object" && values[key] !== null) {
    //     formData.append(key, JSON.stringify(values[key]));
    //   } else {
    //     formData.append(key, values[key]);
    //   }
    // }

    // const headers = { "content-type": "multipart/form-data" };
    setLoading(true);
    performRequest("POST", "/enquiryWebhook/createEnquiry/", values)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Enquiry Created Cuccessfully!");
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div>
      <Helmet>
        <title>
          {`NHM Goverment Subsidy in ${city}, ${state} - Kryzen Biotech`}
        </title>
        <meta
          name="description"
          content={`Check NHM goverment subsidy eligibility in ${city}, ${state}. Get up to 85% subsidy for protected farming & hydroponics.`}
        />
        <meta
          name="keywords"
          content={`
      NHM subsidy ${city}, 
      NHM subsidy ${state}, 
      NHM government subsidy in ${city}, 
      NHM government subsidy in ${state}, 
      hydroponic subsidy ${city}, 
      hydroponic subsidy ${state}, 
      protected farming subsidy ${city}, 
      protected farming subsidy ${state}, 
      polyhouse subsidy ${city}, 
      polyhouse subsidy ${state}, 
      greenhouse subsidy ${city}, 
      greenhouse subsidy ${state}, 
      Kryzen Biotech subsidy ${city}, 
      Kryzen Biotech subsidy ${state}
    `}
        />
        <meta
          property="og:title"
          content={`NHM Subsidy in ${city}, ${state}`}
        />
        <meta
          property="og:description"
          content={`Apply for NHM goverment subsidy in ${city}, ${state}. Free consultation & quick approval assistance.`}
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={`https://alpha.kryzen.com/nhm-government-subsidy/${state}/${city}`}
        />
        <link
          rel="canonical"
          href={`https://alpha.kryzen.com/nhm-government-subsidy/${state}/${city}`}
        />
      </Helmet>
      <div className="px-3 px-md-8 ms-md-8 me-md-8  py-4">
        <h1
          className="text-center fw-bold text-uppercase"
          style={{ fontSize: "2.2rem" }}
        >
          NHM Goverment Subsidy in {city}, {state}!
        </h1>
        <hr></hr>
        <div className="row">
          <div className="col-12 col-md-8">
            <div className="p-1 p-md-2">
              {/* Content Section */}
              <div className="">
                <h2 className="lh-lg fs-1 text-center">
                  The{" "}
                  <strong>National Horticulture Mission (NHM) subsidy</strong>{" "}
                  helps farmers, agri-entrepreneurs, and startups in {state},
                  including {city}, Pune, and Nashik, adopt{" "}
                  <strong>
                    hydroponics, polyhouses, shade nets, and drip irrigation
                  </strong>
                  .<strong>Kryzen Biotech</strong> provides expert guidance in
                  planning, documentation, and execution to make projects
                  subsidy-ready and sustainable. We specialize in{" "}
                  <strong>modern hydroponic farming solutions</strong> that
                  improve productivity and profitability.
                </h2>
                <img
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1755844978/2_ff49gy.jpg"
                  alt="middle img"
                  className="w-100 my-3"
                />
                {/* <p className="fs-6 lh-lg mt-3">
                  Eligible beneficiaries can avail <strong>interest subvention of 3% per annum</strong> on loans up to ₹2 crore for 7 years. <strong>Credit guarantee coverage</strong> is available for loans up to ₹2 crore, easing collateral requirements.
                </p>

                <p className="fs-6 lh-lg">
                  Hydroponics projects in <strong>{city}</strong> benefit from reduced financial burden for NFT systems, deep-water culture, vertical farming, and protected cultivation, especially in {state}.
                </p>

                <p className="fs-6 lh-lg">
                  The scheme also supports <strong>FPOs, startups, and agri-tech companies</strong> for collaborative hydroponics projects and commercial-scale farms. Kryzen Biotech helps in project preparation, subsidy consultation, and execution.
                </p> */}
                <p className="fs-2 lh-lg mt-5">
                  Hydroponics is a soilless farming technique that ensures
                  higher yields, faster crop cycles, and better quality produce
                  compared to traditional soil-based agriculture. The NHM
                  subsidy makes it financially viable for small and medium
                  farmers to adopt hydroponics by covering a significant
                  percentage of project costs.
                </p>{" "}
                <p className="fs-2 lh-lg">
                  For farmers in <strong>{state}</strong>, the NHM subsidy plays
                  a crucial role in tackling challenges such as unpredictable
                  monsoons, rising input costs, and limited availability of
                  fertile land. Cities like <strong>{city}</strong> and Pune
                  have witnessed growing interest in urban hydroponics and
                  rooftop farming, where the NHM scheme has been instrumental in
                  kickstarting projects.
                </p>
                <p className="fs-2 lh-lg">
                  Beyond financial assistance, NHM also provides{" "}
                  <strong>technical guidance</strong>, capacity-building
                  workshops, and farmer training programs. These
                  knowledge-sharing initiatives are designed to help farmers
                  optimize resource use, maintain the correct pH and EC levels,
                  and adopt the best practices in nutrient management. With{" "}
                  {state} being one of the largest horticultural states in
                  India, the NHM subsidy ensures that modern farming
                  technologies are accessible to grassroots farmers.
                </p>
                <p className="fs-2 lh-lg">
                  If you are a farmer, agri-startup, or entrepreneur in {state}
                  looking to set up a hydroponics project in{" "}
                  <strong>{city}</strong> or any other district, applying for
                  the NHM subsidy can drastically reduce your investment burden.
                  Our team at <strong>Kryzen Biotech</strong> specializes in
                  subsidy consultation, project design, and turnkey
                  implementation.
                </p>
                {/* <p className="fs-2 lh-lg">
                  {" "}
                  In conclusion, the <strong>AIF Hydroponic Subsidy</strong> is
                  a golden opportunity for farmers and agri-entrepreneurs in{" "}
                  {state}. Whether you are based in {city} or agricultural belts
                  like Nashik, Pune, and Nagpur, the AIF scheme offers{" "}
                  <strong>
                    {" "}
                    affordable financing, interest subvention, and credit
                    support{" "}
                  </strong>{" "}
                  for building future-ready farming infrastructure.{" "}
                </p> */}
              </div>
            </div>
          </div>

          <div className="col-12 col-md-4 mt-4 mt-md-5 p-3 border d-flex flex-column  align-items-center">
            {/* Form Section */}
            <div>
              <Formik
                initialValues={enquiryInfo}
                validationSchema={enquirySchema}
                onSubmit={handelSubmit}
                enableReinitialize
              >
                {(props) => (
                  <Form
                    className="card p-3 p-md-5 bg-green-lt"
                    // style={{ backgroundColor: "lightgreen" }}
                  >
                    <h2
                      className="fs-2 fs-md-3 text-center mb-3"
                      style={{ color: "black" }}
                    >
                      Join an expert call for national horticulture mission(NHM)
                      subsidy in {city}, {state}
                    </h2>
                    <hr></hr>
                    <div className="mb-3">
                      <label className="form-label required" style={{ color: "black" }}>
                        First Name
                      </label>
                      <CustomInput name="firstName" type="text" />
                      {props.touched.firstName && props.errors.firstName && (
                        <p className="text-danger">{props.errors.firstName}</p>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label required" style={{ color: "black" }}>
                        Last Name
                      </label>
                      <CustomInput name="lastName" type="text" />
                      {props.touched.lastName && props.errors.lastName && (
                        <p className="text-danger">{props.errors.lastName}</p>
                      )}
                    </div>

                    {/* <div className="mb-3">
                      <label
                        className="form-label required"
                        style={{ color: "black" }}
                      >
                        Full Name
                      </label>
                      <CustomInput name="fullName" type="text" />
                      {props.touched.fullName && props.errors.fullName && (
                        <p className="text-danger">{props.errors.fullName}</p>
                      )}
                    </div> */}

                    <div className="mb-3">
                      <label
                        className="form-label required"
                        style={{ color: "black" }}
                      >
                        Mobile Number
                      </label>
                      <CustomInput name="mobileNumber" type="text" />
                      {props.touched.mobileNumber &&
                        props.errors.mobileNumber && (
                          <p className="text-danger">
                            {props.errors.mobileNumber}
                          </p>
                        )}
                    </div>

                    <div className="mb-3">
                      <label
                        className="form-label"
                        style={{ color: "black" }}
                      >
                        Email
                      </label>
                      <CustomInput name="email" type="text" />
                      {props.touched.email && props.errors.email && (
                        <p className="text-danger">{props.errors.email}</p>
                      )}
                    </div>

                    <div className="text-center mt-3">
                      {/* <FormSubmitButton buttonText="Submit" /> */}
                      <button
                        class="btn btn-github  btn mx-1 mt-2 text-center"
                        isSubmitting={props.isSubmitting}
                      >
                        <BsBoxArrowInRight className="fs-2 me-2"></BsBoxArrowInRight>
                        Submit
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
            <div className="mt-5">
              <img
                className="w-100"
                style={{ height: "740px" }}
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1755844954/sidebar_id3qyb.jpg"
                alt="conditions img"
              />
            </div>
          </div>
        </div>

        {/* Conditions Section */}
        <div className="row mt-7">
          <div className="col-12 col-md-4 mt-4 mt-md-0 d-flex justify-content-center align-items-center">
            <img
              className="card"
              style={{ height: "500px", width: "350px" }}
              src="https://res.cloudinary.com/bsgfcooa/image/upload/v1755844954/subsidy_conditions_u2p8a1.jpg"
              alt="benefits img"
            />
          </div>
          <div className="col-12 col-md-8 ps-md-2">
            <h2 className="fw-bold text-uppercase mb-3 fs-1 mt-5 mt-md-0 mt-lg-0">
              NHM Subsidy Conditions
            </h2>
            <hr />
            <p className="mt-4 fs-2 lh-lg">
              The <b>National Horticulture Mission (NHM)</b> subsidy scheme is
              aimed at supporting farmers and agri-entrepreneurs in building
              modern protected cultivation infrastructure such as polyhouses,
              shade nets, and greenhouses. With subsidy support ranging from 35%
              to 50%, NHM reduces the investment burden and encourages adoption
              of climate-resilient and sustainable farming practices. Kryzen
              Biotech assists beneficiaries at every stage—right from project
              planning and compliance with NHM standards to subsidy application
              and technical execution—ensuring farmers maximize both the
              financial support and long-term benefits of the scheme.
            </p>
            <ol className="fs-2 lh-lg ">
              <li>
                <strong>Eligibility:</strong> Farmers, FPOs, SHGs, NGOs, and
                agri-entrepreneurs with valid land ownership/lease.
              </li>
              <li>
                <strong>Area Limit:</strong> Minimum project size as per scheme,
                maximum up to 4000 sq. m. per beneficiary.
              </li>
              <li>
                <strong>Subsidy Support:</strong> 35% – 50% subsidy on project
                cost, with higher support for SC/ST, women, and FPOs.
              </li>
              <li>
                <strong>Technical Standards:</strong> Structures must comply
                with NHM/NHB/BIS-approved designs & quality norms.
              </li>
              <li>
                <strong>Release Process:</strong> Subsidy disbursed in
                installments after verification by horticulture officers.
              </li>
              <li>
                <strong>Implementation Timeline:</strong> Project completion
                within 12 months of sanction (extensions need approval).
              </li>
              <li>
                <strong>Restrictions:</strong> Cannot claim subsidy from
                multiple schemes for the same project.
              </li>
              <li>
                <strong>Maintenance:</strong> Beneficiaries must maintain the
                structure for at least 5 years.
              </li>
            </ol>
          </div>
        </div>

        {/* Benefits Section */}
        <div className="row mt-7">
          <div className="col-12 col-md-8">
            <h2 className="fw-bold mb-3 text-uppercase fs-1">Benefits</h2>
            <hr />
            <p className="mt-4 fs-2 lh-lg">
              These benefits are transforming agriculture into a more
              sustainable and profitable venture for farmers and agri-startups.
              By reducing financial risks and promoting advanced farming systems
              like hydroponics and polyhouses, growers can achieve higher
              yields, improved quality, and better market access.{" "}
              <b>Kryzen Biotech</b> strengthens this progress by offering expert
              training, technical support, and project execution, enabling
              farmers to embrace climate-resilient farming practices and scale
              their agribusiness with confidence.
            </p>
            <ol className="fs-2 lh-lg">
              <li>Reduces investment burden on farmers & startups.</li>
              <li>
                Encourages adoption of modern farming like hydroponics,
                polyhouse & protected cultivation.
              </li>
              <li>
                Provides training, workshops & technical guidance for
                sustainable farming.
              </li>
              <li>
                Supports climate-proof farming against erratic monsoons & water
                scarcity.
              </li>
              <li>
                Boosts productivity, crop quality & access to local + export
                markets.
              </li>
            </ol>
          </div>
          <div className="col-12 col-md-4 mt-4 mt-md-0 d-flex justify-content-center align-items-center">
            <img
              className="card"
              style={{ height: "500px", width: "350px" }}
              src="https://res.cloudinary.com/bsgfcooa/image/upload/v1755844954/benifits_v6xubk.jpg"
              alt="benefits img"
            />
          </div>
        </div>
        {/* <hr></hr> */}

        <hr></hr>
        <div className="row mt-7">
          {/* Image Section */}
          <div className="col-12 col-md-5 mt-4 mt-md-0 d-flex justify-content-center align-items-center mb-4 mb-md-0">
            <img
              className="card img-fluid"
              style={{ maxHeight: "500px", width: "100%", objectFit: "cover" }}
              src="https://res.cloudinary.com/bsgfcooa/image/upload/v1756358719/shark_tank_uvzuuq.jpg"
              alt="Shark Tank"
            />
          </div>

          {/* Text Section */}
          <div className="col-12 col-md-6 ps-md-2 ms-md-5  text-md-start">
            <h1 className="fw-bold text-uppercase mb-3 fs-1 mt-3 mt-md-0">
              We build best protected farming technology for the world!
            </h1>
            <hr className="mx-auto mx-md-0" />
            <p className="mt-4 fs-2 lh-lg">
              Build a commercially profitable farm anywhere and earn up to
              ₹1,25,000 per month from just 5000 sqft.
            </p>
            <p className="mt-4 fs-2 lh-lg">
              We are top turnkey commercial hydroponics farm project development
              company. We set up hydroponic farms that are low in capex and high
              in returns on investment. With fastest ROI mechanism, We develop
              farm that generates good returns in lowest possible time.
            </p>
          </div>
        </div>

        <div>
          <div className="mt-7">
            <h3 className="fs-1 pb-3 text-uppercase">
              Why Choose NHM Subsidy in {city}, {state}?
            </h3>
            <hr></hr>
            <ol className="fs-2 lh-lg">
              <li>85% subsidy for farmers & startups in {state}</li>
              <li>
                Hydroponic polyhouse projects with DPR & CAPEX/OPEX planning
              </li>
              <li>Faster approval with Kryzen’s government liaisoning</li>
              <li>100+ projects executed across India</li>
            </ol>
          </div>

          <div>
            <h2 className="fs-2 pb-1">Case Studies in {state} :</h2>
            <p className="fs-2">
              A 1-acre hydroponic farm in {city}, {state} was completed with 75%
              NHM subsidy. CAPEX: ₹1.2 Cr, OPEX: ₹12 Lakh/year.
            </p>
          </div>
        </div>

        <div className="row mt-7">
          <h3 className="fs-1 pb-3 text-uppercase">Conclusion</h3>
          <hr></hr>
          <p className="fs-2">
            In conclusion, the <strong>NHM Hydroponic Subsidy</strong> is a
            game-changer for farmers in {state}. Whether you are based in urban
            areas like {city} or agricultural belts like Nashik, the NHM subsidy
            opens doors to a future-ready farming model that is efficient,
            scalable, and profitable.
          </p>
        </div>
        <div className="row mt-7">
          <div className="row">
            <h2 className="fw-bold text-uppercase mb-3 fs-1">
              Explore NHM Government Subsidy in Other Cities of {state}
            </h2>
            <hr />

            {district.slice(0, 15).map((city, index) => (
              <div key={index} className="col-12 col-md-4 col-lg-4">
                <ul className="fs-3 lh-lg">
                  <li>
                    <a
                      href={`/nhm-government-subsidy/${state}/${city.toLowerCase()}`}
                      className="text-decoration-none text-success"
                    >
                      NHM Government Subsidy in {city}, {state}
                    </a>
                  </li>
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="section my-3 py-4">
          <div className="row text-center my-6">
            <h2 className="hero-title display-6 fw-bold">FAQ's</h2>
            <h3 className="section-description my-0 p-0">
              Questions that asked by most of people.
            </h3>
          </div>

          <div className="row">
            <div className="col-md-6 col-sm-12">
              <div class="accordion" id="accordion-default">
                <div class="accordion-item">
                  <div class="accordion-header">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse-1-default"
                      aria-expanded="false"
                    >
                      Who is eligible for NHM government subsidy in {city},{" "}
                      {state}?<div class="accordion-button-toggle"></div>
                    </button>
                  </div>
                  <div
                    id="collapse-1-default"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordion-default"
                  >
                    <div class="accordion-body">
                      Farmers, FPOs, agri-entrepreneurs, startups, and
                      agri-companies in {city}, {state} can apply for NHM
                      subsidy. Both small and large landholders are eligible,
                      provided they meet the scheme’s protected cultivation and
                      hydroponics guidelines.
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <div class="accordion-header">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse-2-default"
                      aria-expanded="false"
                    >
                      How much subsidy is offered under NHM in {city}, {state}?
                      <div class="accordion-button-toggle"></div>
                    </button>
                  </div>
                  <div
                    id="collapse-2-default"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordion-default"
                  >
                    <div class="accordion-body">
                      Eligible applicants in {city}, {state} can get up to
                      50%–85% subsidy on polyhouse, hydroponics, greenhouse, and
                      protected cultivation projects depending on project type
                      and beneficiary category.
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <div class="accordion-header">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse-3-default"
                      aria-expanded="false"
                    >
                      What is the process to apply for NHM subsidy in {city},{" "}
                      {state}?<div class="accordion-button-toggle"></div>
                    </button>
                  </div>
                  <div
                    id="collapse-3-default"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordion-default"
                  >
                    <div class="accordion-body">
                      Applicants must submit a project report, land documents,
                      and required forms through the state horticulture
                      department. Kryzen Biotech assists with subsidy paperwork,
                      DPR preparation, and end-to-end execution.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-sm-12">
              <div class="accordion" id="accordion-second">
                <div class="accordion-item">
                  <div class="accordion-header">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse-4-default"
                      aria-expanded="false"
                    >
                      Does NHM subsidy cover hydroponic farming in {city},{" "}
                      {state}?<div class="accordion-button-toggle"></div>
                    </button>
                  </div>
                  <div
                    id="collapse-4-default"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordion-default"
                  >
                    <div class="accordion-body">
                      Yes, NHM subsidy supports modern farming methods like
                      hydroponics, polyhouse, and greenhouse farming in {city},{" "}
                      {state}, encouraging farmers to adopt sustainable and
                      high-yield practices.
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <div class="accordion-header">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse-22-default"
                      aria-expanded="false"
                    >
                      How long does it take to get NHM subsidy approval in{" "}
                      {city}, {state}?
                      <div class="accordion-button-toggle"></div>
                    </button>
                  </div>
                  <div
                    id="collapse-22-default"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordion-second"
                  >
                    <div class="accordion-body">
                      On average, the approval process may take 3–6 months
                      depending on project size, completeness of documents, and
                      state department verification in {city}, {state}.
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <div class="accordion-header">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse-33-default"
                      aria-expanded="false"
                    >
                      Why choose Kryzen Biotech for NHM subsidy projects in{" "}
                      {city}, {state}?
                      <div class="accordion-button-toggle"></div>
                    </button>
                  </div>
                  <div
                    id="collapse-33-default"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordion-second"
                  >
                    <div class="accordion-body">
                      Kryzen Biotech is India’s leading EPC company in
                      hydroponics and polyhouse projects, featured on Shark Tank
                      India. We provide subsidy consultation, DPRs, turnkey
                      setup, and after-sales support, ensuring farmers in {city}
                      , {state} get maximum benefits.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr></hr>
        <div className="row">
          <div className="col-12">
            <img
              className="w-100"
              // style={{height:"380px"}}
              src="https://res.cloudinary.com/bsgfcooa/image/upload/v1755844969/footer_jclvvn.jpg"
              alt="footer img"
            ></img>
          </div>
        </div>
      </div>
      <FooterwithoutLogin />
    </div>
  );
};

export default NHMSubsidy;
